/* Fresh Start "Style" picker (design-group PREVIEW).
 * Swaps to the same design in another style. Keeps the chosen colour/size when that
 * combination exists on the target product (?variant=ID). Tries a seamless swap first
 * (fetch the target page, replace the product sections in place, keep the scroll position);
 * falls back to a normal page load on any problem. */
(function () {
  if (customElements.get('fs-style-picker')) return;

  let fsSwapped = false;
  const norm = (s) => String(s || '').trim().toLowerCase();

  function currentOptions(sectionId) {
    // Read the selected value of every option (dropdown or pill) from the theme's variant picker.
    const out = {};
    const vs = document.querySelector(`variant-selects[data-section="${sectionId}"]`);
    if (!vs) return out;
    vs.querySelectorAll('select[name^="options["]').forEach((sel) => {
      out[norm(sel.name.slice(8, -1))] = sel.value;
    });
    vs.querySelectorAll('fieldset').forEach((fs) => {
      const checked = fs.querySelector('input[type="radio"]:checked');
      const legend = fs.querySelector('legend');
      if (checked && legend) out[norm(legend.textContent.split(':')[0])] = checked.value;
    });
    return out;
  }

  function pickVariant(product, wanted) {
    const names = product.options.map((o) => norm(o.name || o));
    const score = (v) => {
      let s = 0;
      names.forEach((n, i) => {
        if (wanted[n] !== undefined && norm(v.options[i]) === norm(wanted[n])) s += n === 'color' || n === 'colour' ? 2 : 1;
      });
      return s;
    };
    let best = null;
    let bestScore = -1;
    product.variants.forEach((v) => {
      const s = score(v) + (v.available ? 0.5 : 0);
      if (s > bestScore) { best = v; bestScore = s; }
    });
    return best;
  }

  class FsStylePicker extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onChange);
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
    }

    async onChange(event) {
      const input = event.target;
      if (!input || input.type !== 'radio') return;
      const baseUrl = input.dataset.url;
      const sectionId = this.dataset.section;
      this.classList.add('is-loading');
      let target = baseUrl;
      try {
        const wanted = currentOptions(sectionId);
        const res = await fetch(`${baseUrl}.js`, { headers: { Accept: 'application/json' } });
        if (res.ok) {
          const product = await res.json();
          const variant = pickVariant(product, wanted);
          if (variant) target = `${baseUrl}?variant=${variant.id}`;
        }
      } catch (e) { /* fall through with the plain URL */ }

      try {
        await this.swap(target, sectionId, input.value);
      } catch (e) {
        window.location.assign(target);
      }
    }

    async swap(url, sectionId, handle) {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('fetch failed');
      const html = new DOMParser().parseFromString(await res.text(), 'text/html');
      const newMain = html.getElementById('MainContent');
      const oldMain = document.getElementById('MainContent');
      // Only swap when the target renders the same product section with this picker in it.
      const newSection = html.getElementById(`shopify-section-${sectionId}`);
      if (!newMain || !oldMain || !newSection || !newSection.querySelector('fs-style-picker')) throw new Error('layout mismatch');

      // Keep the picker at the same spot on screen (falls back to the same scroll offset).
      const pickerTop = this.getBoundingClientRect().top;
      const scrollY = window.scrollY;
      oldMain.innerHTML = newMain.innerHTML;
      document.title = html.title;
      ['description', 'og:title', 'og:url', 'og:image', 'og:description'].forEach((name) => {
        const sel = name.startsWith('og:') ? `meta[property="${name}"]` : `meta[name="${name}"]`;
        const a = document.querySelector(sel);
        const b = html.querySelector(sel);
        if (a && b) a.setAttribute('content', b.getAttribute('content'));
      });
      const canon = document.querySelector('link[rel="canonical"]');
      const canonNew = html.querySelector('link[rel="canonical"]');
      if (canon && canonNew) canon.href = canonNew.href;

      history.pushState({ fsStyle: true }, '', url);
      fsSwapped = true;
      const newPicker = document.querySelector(`fs-style-picker[data-section="${sectionId}"]`);
      const anchor = () => {
        if (newPicker && newPicker.isConnected) window.scrollTo(0, window.scrollY + newPicker.getBoundingClientRect().top - pickerTop);
      };
      if (newPicker) {
        anchor();
        // Re-anchor while late layout (images, fonts) settles, unless the shopper scrolls first.
        let userScrolled = false;
        const stop = () => { userScrolled = true; };
        window.addEventListener('wheel', stop, { once: true, passive: true });
        window.addEventListener('touchmove', stop, { once: true, passive: true });
        [60, 250, 600, 1200].forEach((ms) => setTimeout(() => { if (!userScrolled) anchor(); }, ms));
      } else window.scrollTo(0, scrollY);
      const checked = document.querySelector(`fs-style-picker[data-section="${sectionId}"] input:checked`);
      if (checked) checked.focus({ preventScroll: true });
      document.dispatchEvent(new CustomEvent('fs:style-swapped', { detail: { url, handle } }));
    }
  }

  customElements.define('fs-style-picker', FsStylePicker);

  // Back/forward after a seamless swap: reload so the page always matches the URL.
  // (The theme's variant picker rewrites history.state, so track swaps with a flag instead.)
  window.addEventListener('popstate', () => {
    if (fsSwapped) window.location.reload();
  });
})();
